import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import { ReduceStore } from 'flux/utils';
import update from 'immutability-helper';


const JobStatus = {
    1: "waiting",
    2: "assigned",
    3: "running",
    4: "finished",
    8: "failed",
    9: "aborted",
};

const sanitise = (job, taskId) => ({
    ...job,
    taskId,
    statusId: job.status,
    status: JobStatus[job.status]
});

const normalize = (data, taskId) => {
    const result = [], jobs = {};
    data.forEach(job => {
        const { id } = job;
        result.push(id);
        jobs[id] = sanitise(job);
    });
    return {result, jobs};
};

class SystemTaskJobStore extends ReduceStore {

    isFetching() {
        return this.getState().isFetching;
    }

    getJobs(taskId) {
        const { jobIds, jobs } = this.getState();
        if (!jobIds[taskId] || !jobs[taskId] ) { return []; }
        return jobIds[taskId].map(id => jobs[taskId][id]);
    }

    getIdLimits(taskId) {
        const ids = this.getState().jobIds[taskId];
        return (!!ids ? {min: Math.min(...ids), max: Math.max(...ids)} : {min: null, max: null});
    }

    getInitialState() {
        return {
            isFetching: false,
            jobIds: {},
            jobs: {}
        };
    }

    reduce(state, action) {
        let jobIds;

        switch (action.type) {
            case ActionTypes.SYSTEM_TASK_JOB_LIST_REQUEST:
                return {
                    ...state,
                    isFetching: true
                };

            case ActionTypes.SYSTEM_TASK_JOB_LIST_SUCCESS:
                if (!action.payload.taskId) { return state; }
                const { result, jobs } = normalize(action.data, action.payload.taskId);

                jobIds = (!!state.jobIds[action.payload.taskId] ? result.filter(i => !!i && !!state.jobIds[taskId].includes(i)) : result);
                return update(this.getState(), {
                    isFetching: { $set: false },
                    jobs: {
                        [action.payload.taskId]: (
                            !!state.jobs[action.payload.taskId]
                                ? { $merge: jobs}
                                : { $set: jobs}
                        )
                    },
                    jobIds: {
                        [action.payload.taskId]: (
                            !!state.jobs[action.payload.taskId]
                                ? { $merge: jobIds}
                                : { $set: jobIds}
                        )
                    }
                });

            case ActionTypes.SYSTEM_TASK_JOB_LIST_FAILURE:
                return update(this.getState(), { isFetching: { $set: false }});

            default:
                return state;
        }
    }
}

export default new SystemTaskJobStore(CentricDispatcher);
